const StreamedEvents = require('../StreamedEvents');
const View = require('../../../../../_lib/core/View');

class EditPendingItemModal extends View {
  constructor(modal) {
    super('edit-pending-item-modal');

    this.modal = modal;

    this.streamedEventsEl = modal.find('select[name=streamed_events]');
    this.recordingOptionEl = modal.find('select[name=recording_option]');
  }

  init() {
    this.bindElements();
  }

  bindElements() {
    this.modal.on('show.bs.modal', (e) => {
      this.onShowModal(e);
    });
  }

  onShowModal(e) {
    const btn = $(e.relatedTarget);

    this.currentButton = btn;
    this.buttonData = btn.data();

    this.streamedEvents = new StreamedEvents(this, this.streamedEventsEl, this.recordingOptionEl);
  }

  animate() {
    this.wrapper.fadeTo(0, 0);
    setTimeout(() => {
      this.wrapper.fadeTo(200, 1);
    }, 300);
  }
}

module.exports = (el) => {
  new EditPendingItemModal($(el)).init();
};
